/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable-next-line react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, LayersControl, Polyline, LayerGroup, Pane } from 'react-leaflet';
import { DivIcon } from 'leaflet';
import './Map.css';
import 'leaflet/dist/leaflet.css';
import PopupCT from './PopupCT';
import PopupINV from "./PopupINV";
import PopupPR from "./PopupPR";
import PopupTCU from './PopupTCU';
import PopupNCU from './PopupNCU';
import PopupRSU from './PopupRSU';
import { json } from 'react-router-dom';

function Map(props) {
  var idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);
  const { code, filter } = props;

  

  // *********************************************************************************************************************************************************************************
  // -------------------------------------------------------------------------- Zonas ------------------------------------------------------------------------------------------------
  var [Zona, setZona] = useState([]);
  var [htmlZona, setHtmlZona] = useState(<></>); 
  let number = 0;
  useEffect(()=> {
      setZona(JSON.parse(sessionStorage.getItem('ZoneConfiguration')));
      updateData('inverter');
      updateData('CT');
      updateData('NCU');
      updateData('tracker');
      updateData('meteo');
      var mapInterval = setInterval(() => {
        number++;
        if(code == sessionStorage.getItem("key")) { // No ha cambiado de página
          updateData('inverter');
          updateData('CT');
          updateData('NCU');
          updateData('tracker');
          updateData('meteo');
        } else {
          clearInterval(mapInterval);
        }
      }, 30000)
    },[number]);

  useEffect(()=>{
    htmlZona = Zona.map((datoZona, index) =>{
      const { id, idSolarFarm, name, coordinates } = datoZona;
      return(<Polyline key={index} positions={coordinates} pathOptions={{weight: 6}}/>);
    });
    setHtmlZona(htmlZona);
  },[Zona]);

  // *********************************************************************************************************************************************************************************
  // -------------------------------------------------------------------------- CT ---------------------------------------------------------------------------------------------------
  var [CT, setCT] = useState([]);
  var [htmlCT, setHtmlCT] = useState(<></>);

  useEffect(()=>{
    
    htmlCT = CT.map((datoCT, index) => {
      const { id, idSolarFarm, idCT, name, CTDescription, coordX, coordY,status,color } = datoCT;
      var alias = id;
      if(datoCT.alias) {
        alias = datoCT.alias;
      }

      var svgCT = '<svg width="30" height="30" viewBox="0 0 30 30">'
                + '<rect style="opacity:1;fill:'+color+';fill-opacity:1;stroke:none;stroke-width:0.1;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" id="fondo" width="30" height="30" x="0" y="0" ry="1.8520833"><animateTransform attributeName="transform" type="rotate" from="0 0 0" to="45 0 0" dur="0s"/></rect>'
                + '<defs id="defs2"><rect x="7.0233051" y="8.5487288" width="15.317797" height="15.063559" id="rect170" /></defs>'
                + '<text id="texto" style="white-space:pre;shape-inside:url(#rect170);fill:#000000"><tspan x="50%" y="55%" dominant-baseline="middle" text-anchor="middle">' + alias + '</tspan></text>'
                + '</svg>'
      return(<Marker key={index} position={[coordX, coordY]} icon={new DivIcon({className:"div-icon-map", html: svgCT})} riseOnHover={true} pane={"tooltipPane"} zIndexOffset={0}><Popup closeButton={false}><PopupCT id={idCT} nombre={name} estado={status} color={color}/></Popup></Marker>);
    });
    setHtmlCT(htmlCT);
  },[CT]);

  // ***********************************************************************************************************************************************************************************
  // -------------------------------------------------------------------------- INV ----------------------------------------------------------------------------------------------------
  var [INV, setINV] = useState([]);
  var [htmlINV, setHtmlINV] = useState(<></>);

  useEffect(()=>{
    // FILTRADO DE DATOS POR ESTADO
    let datosAMapear = [];
    datosAMapear = filter.includes('INV-OK') ? datosAMapear.concat(INV.filter(a => a.statusLevel === 0)) : datosAMapear;
    datosAMapear = filter.includes('INV-WARNING') ? datosAMapear.concat(INV.filter(a => a.statusLevel === 1)) : datosAMapear;
    datosAMapear = filter.includes('INV-ALARM') ? datosAMapear.concat(INV.filter(a => a.statusLevel === 2)) : datosAMapear;
    datosAMapear = filter.includes('INV-COM') ? datosAMapear.concat(INV.filter(a => a.statusLevel === 3)) : datosAMapear;
    if(!filter.includes('INV-OK') && !filter.includes('INV-WARNING') && !filter.includes('INV-ALARM') && !filter.includes('INV-COM')) {
      datosAMapear = INV;
    }

    htmlINV = datosAMapear.map((datoINV, index) => {
      const { id, idSolarFarm, idCT, idInverter, name, inverterDescription, coordX, coordY,status,color, nominalPower,activePower,reactivePower,energyDay,strings,produciendo,peakPower,productivity, statusLevel } = datoINV;
      
      var _pane; // Capa en la que se muestra el marker
      statusLevel > 0 ? _pane = "tooltipPane" : _pane = "markerPane"; // Si el offSet es superior a 1, colocar en capa de toolTip (capa superior), sino en la capa inferior markerPane
      var svgINV = '<svg width="20" height="20">'
      +'<rect style="opacity:0.89;fill:'+color+';fill-opacity:1;stroke:#000000;stroke-width:0.192066;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" id="fondo" width="20" height="20" ry="1.5" /> </svg>';
      return(<Marker key={index} position={[coordX, coordY]} icon={new DivIcon({className:"div-icon-map", html: svgINV})} riseOnHover={true} zIndexOffset={1} title={name} pane={_pane}><Popup closeButton={false}>
        <PopupINV nombre={name} idCT={idCT} idINV={idInverter} estado={status} color={color} potNominal={nominalPower} potActiva={activePower} energyDay={energyDay} strings={strings} produciendo={produciendo} 
        potPico={peakPower} pr={productivity}/></Popup></Marker>);
    });
    setHtmlINV(htmlINV);
  },[INV, filter]);

  // ***********************************************************************************************************************************************************************************
  // -------------------------------------------------------------------------- PR  ----------------------------------------------------------------------------------------------------
  var [PR, setPR] = useState([]);
  var [htmlPR, setHtmlPR] = useState(<></>);
  useEffect(()=>{
    htmlPR = PR.map((datoINV, index) => {
      const { id, idSolarFarm, idCT, idInverter, name, coordX, coordY, productivity, productivityColor, productivityStatus, prStatusLevel } = datoINV;
      
      var _pane; // Capa en la que se muestra el marker
      prStatusLevel > 0 ? _pane = "tooltipPane" : _pane = "markerPane"; // Si el offSet es superior a 1, colocar en capa de toolTip (capa superior), sino en la capa inferior markerPane
      var svgINV = '<svg width="20" height="20">'
      +'<rect style="opacity:0.89;fill:'+productivityColor+';fill-opacity:1;stroke:#000000;stroke-width:0.192066;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" id="fondo" width="20" height="20" ry="1.5" /> </svg>';
      return(<Marker key={index} position={[coordX, coordY]} icon={new DivIcon({className:"div-icon-map", html: svgINV})} riseOnHover={true} zIndexOffset={1} title={name} pane={_pane}><Popup closeButton={false}>
        <PopupPR nombre={name} idCT={idCT} idINV={idInverter} color={productivityColor} pr={productivity} status={productivityStatus}/></Popup></Marker>);
    });
    setHtmlPR(htmlPR);
  },[PR]);

  // *********************************************************************************************************************************************************************************
  // -------------------------------------------------------------------------- NCU --------------------------------------------------------------------------------------------------
  var [NCU, setNCU] = useState([]);
  var [htmlNCU, setHtmlNCU] = useState(<></>);

  useEffect(()=>{
    htmlNCU = NCU.map((datoNCU, index) => {
      const { id, idSolarFarm, idNCU, NCUDescription, trackers, trackersOk, trackersWarning, trackersBad, trackersNoComm, statusColor, okTrackersPercent, coordX, coordY } = datoNCU;
      var svgNCU = '<svg width="50" height="50"><g id="layer1"> <circle style="fill:' + statusColor + ' ;stroke:none;stroke-width:0.1" id="circulo" cx="20" cy="20" r="20" />'
      + '<text id="texto" style="white-space:pre;shape-inside:url(#rect170);fill:#000000"><tspan x="40%" y="45%" dominant-baseline="middle" text-anchor="middle">' + idNCU + '</tspan></text> </g> </svg>'
      return(<Marker key={index} position={[coordX, coordY]} icon={new DivIcon({className:"div-icon-map", html: svgNCU})} riseOnHover={true} zIndexOffset={1} title={idNCU}><Popup closeButton={false}><PopupNCU idNCU={idNCU} tcu={trackers} tcuOk={trackersOk} tcuWarning={trackersWarning} tcuBad={trackersBad} tcuNoComm={trackersNoComm}/></Popup></Marker>);
    });
    setHtmlNCU(htmlNCU);
  },[NCU]);

  // *********************************************************************************************************************************************************************************
  // -------------------------------------------------------------------------- TCU --------------------------------------------------------------------------------------------------
  var [TCU, setTCU] = useState([]);
  var [htmlTCU, setHtmlTCU] = useState(<></>);
  
  useEffect(()=>{
    // FILTRADO DE DATOS POR ESTADO
    let datosAMapear = [];
    datosAMapear = filter.includes('TCU-OK') ? datosAMapear.concat(TCU.filter(a => a.statusLevel === 0)) : datosAMapear;
    datosAMapear = filter.includes('TCU-WARNING') ? datosAMapear.concat(TCU.filter(a => a.statusLevel === 1)) : datosAMapear;
    datosAMapear = filter.includes('TCU-ALARM') ? datosAMapear.concat(TCU.filter(a => a.statusLevel === 2)) : datosAMapear;
    datosAMapear = filter.includes('TCU-COM') ? datosAMapear.concat(TCU.filter(a => a.statusLevel === 3)) : datosAMapear;
    if(!filter.includes('TCU-OK') && !filter.includes('TCU-WARNING') && !filter.includes('TCU-ALARM') && !filter.includes('TCU-COM')) {
      datosAMapear = TCU;
    }

    htmlTCU = datosAMapear.map((dato, index) => {
      const { id, idSolarFarm, idCT,idInverter, idTracker, statusCode, name, coordX, coordY, actualPosition, targetPosition, status, color, zIndexOffSet, notAtSetpoint, stop, motorBlocked, overcurrent, notUsed } = dato;
      var _pane; // Capa en la que se muestra el marker
      var _dimensiones;
      var _rotacion;

      // Genero listado de alarmas activas en el popup
      let textoAlarmas = '';
      textoAlarmas = notAtSetpoint ? 'No en Setpoint' : '';
      textoAlarmas += textoAlarmas.length !== 0 && stop ? ', ' : '';
      textoAlarmas += stop ? 'Stop' : '';
      textoAlarmas += textoAlarmas.length !== 0 && motorBlocked ? ', ' : '';
      textoAlarmas += motorBlocked ? 'Motor bloqueado' : '';
      textoAlarmas += textoAlarmas.length !== 0 && overcurrent ? ', ' : '';
      //textoAlarmas += notAtSetpoint && stop && motorBlocked ? '\n' : '';
      textoAlarmas += overcurrent ? 'Sobrecorriente' : '';
      textoAlarmas += textoAlarmas.length !== 0 && notUsed ? ', ' : '';
      textoAlarmas += notUsed ? 'Baja vel.' : '';

      actualPosition ==='---' || zIndexOffSet > 1  ? _rotacion = 0 : _rotacion = -actualPosition; // Si el offSet es superior a 1 (de warning para arriba), poner rotación del svg a 0
      zIndexOffSet > 1 ? _pane = "tooltipPane" : _pane = "markerPane"; // Si el offSet es superior a 1, colocar en capa de toolTip (capa superior), sino en la capa inferior markerPane
      zIndexOffSet > 1 ? _dimensiones = 'width="42" height="19"' : _dimensiones = 'width="40" height="16"';
      var svgTCU = '<svg transform="translate(-20,-8) rotate(' + _rotacion + ',20,8)" ' + _dimensiones + '>'
                  + '<rect style="opacity:0.89;fill:'+ color +';fill-opacity:1;stroke:#000;stroke-width:1;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;" width="100%" height="100%"/></svg>';
      return(<Marker key={index} position={[coordX, coordY]} icon={new DivIcon({className:"div-icon-map", html: svgTCU})} riseOnHover={true} title={name} pane={_pane}><Popup closeButton={false}><PopupTCU id={id} idCT={idCT} idInverter={idInverter} idTracker={idTracker} name={name} status={status} color={color} position={actualPosition} positionTarget={targetPosition} alarms={textoAlarmas}/></Popup></Marker>);
    }, []);
    setHtmlTCU(htmlTCU);
  },[TCU, filter]);

  // *********************************************************************************************************************************************************************************
  // -------------------------------------------------------------------------- RSU --------------------------------------------------------------------------------------------------
  var [MS, setMS] = useState([]);
  var [htmlMS, setHtmlMS] = useState(<></>);

    useEffect(()=>{
      htmlMS = MS.map((datoMS, index) => {
        const { id, idSolarFarm, idMS, communicationStatusCode, operationStatusCode, communicationStatus, communicationStatusColor, operationStatus, operationStatusColor, name, coordX, coordY, G, GPOA_PYR, GPOA_SI, PHI, TA, RH, PATM, windSpeed, windDirection, TM1, TM2, TM3, TM4, TM5, TM6, QIQ_SOIL1, DIQ_LOSS1, QIQ_SOIL2, DIQ_LOSS2, DIQ_STAT, ERADDAY } = datoMS;
        var svgRSU = '<svg width="50" height="25" viewBox="0 0 15 7"> <g id="layer1"> <g id="g1401"> <path style="fill:none;stroke:#000000;stroke-width:0.166295" d="M 13.57443,5.1939195 13.561136,0.28306109 6.9146261,2.6507748 0.21694498,0.27745887 0.25242948,5.1773314 6.9154805,2.7932225 Z" id="path792" />' 
        + '<path style="fill:' + operationStatusColor + ';stroke:none;stroke-width:0.0740405;stroke-dasharray:none" d="M 0.27611402,0.33533273 6.9176784,2.7194993 0.36573035,5.0664132 Z" id="OperationStatus" />'
        + '<path style="fill:' + communicationStatusColor + ';stroke:none;stroke-width:0.0731684;stroke-dasharray:none" d="M 13.442207,0.39144273 13.452102,5.1039225 6.9019879,2.7136858 Z" id="CommunicationStatus" /> <path style="fill:#ffffff;stroke:#000000;stroke-width:0.1;stroke-dasharray:none" d="m 6.9019464,2.7824086 -0.00983,3.873742" id="path1395" /> </g> </g> </svg>'
        return(<Marker key={index} position={[coordX, coordY]} icon={new DivIcon({html: svgRSU, className:"div-icon-map"})} riseOnHover={true} title={name}><Popup closeButton={false} className="popup-rsu"><PopupRSU name={name} operationStatus={operationStatus} communicationStatus={communicationStatus} operationStatusColor={operationStatusColor} communicationStatusColor={communicationStatusColor}/></Popup></Marker>);
      });
      setHtmlMS(htmlMS);
    },[MS]);

  // *********************************************************************************************************************************************************************************
  // --------------------------------------------------------------------- Actualizar datos ------------------------------------------------------------------------------------------
    function updateData(hook) {
      var preloadedConfig; // Variable que lee el json con la configuración precargada del hook
      let variables = ''; // Variables a solicitar por API
      let url = '';
      switch(hook) {
        case 'CT':
          url = '/lastData/CTs';
          variables = '&variables=id,status,color';
          preloadedConfig = sessionStorage.getItem('CTConfiguration');
          break;
        case 'inverter':
          url = '/lastData/inverters';
          variables = '&variables=id,status,color,activePower,reactivePower,energyDay,productivity,productivityColor,productivityStatus,nominalPower,statusLevel';
          preloadedConfig = sessionStorage.getItem('InverterConfiguration');
          break;
        case 'tracker':
          url = '/lastData/trackers';
          variables = '&variables=id,actualPosition,targetPosition,status,color,zIndexOffSet,statusLevel,notAtSetpoint,stop,motorBlocked,overcurrent,notUsed';
          preloadedConfig = sessionStorage.getItem('TrackerConfiguration');
          break;
        case 'meteo':
          url = '/lastData/meteorologicalStation';
          variables = '&variables=id,communicationStatus,communicationStatusColor,operationStatus,operationStatusColor';
          preloadedConfig = sessionStorage.getItem('MeteoConfiguration');
          break;
        case 'NCU':
          url = '/lastData/NCU';
          variables = '&variables=id,idNCU,status,trackers,trackersOk,trackersWarning,trackersBad,trackersNoComm,statusColor,okTrackersPercent';
          preloadedConfig = sessionStorage.getItem('NCUConfiguration');
          break;
        default:
          console.error('Actualización de datos del mapa: No se ha especificado un hook válido (valor: ' + hook + ').');
          return;
      }
      
      // Generar JSON
      fetch(window.location.protocol+"//"+window.location.hostname+"/api" + url + "?idSolarFarm="+idParque+variables, { method: 'GET', credentials: 'include' })
      .then( async(data) => { 
        let datosLocales = JSON.parse(preloadedConfig); // Datos en sessionStorage
        let datos = await data.json(); // Datos obtenidos por API
        let finalJson = []; // Variable que se asignará al hook indicado.
        for(let i = 0 ; i < datos.length; i++) {
          var aux = datosLocales.filter(a => a.id == datos[i].id)[0]; // Relaciono los datos obtenidos con los guardados en local
          var keys = Object.keys(datos[i]); // Obtengo nombres de las variables obtenidas en fetch para asignarlas al json final
          for(let o = 0; o < keys.length; o++) { 
            aux[keys[o]] = datos[i][keys[o]]; // Añado las variables obtenidas por API al array de objetos guardado en local
          }
          finalJson.push(aux);
        }
        
        // Asignación de datos a los hooks
        switch(hook) {
          case 'CT':
          setCT([]);
          setCT(finalJson);
          break;
        case 'inverter':
          setINV([]);
          setPR([]);
          setINV(finalJson);
          setPR(finalJson);
          break;
        case 'tracker':
          setTCU([]);
          setTCU(finalJson);
          break;
        case 'meteo':
          setMS([]);
          setMS(finalJson);
          break;
        case 'NCU':
          setNCU([]);
          setNCU(finalJson);
          break;
          default:
            console.error('Actualización de datos del mapa: Error asignando los datos al hook (valor: ' + hook + ').');
            return;
        }        
        ;})
      .catch(e => {console.log(e); console.warn(hook); return;})
    }
    
  // *********************************************************************************************************************************************************************************
  // -------------------------------------------------------------------------- Layers -----------------------------------------------------------------------------------------------
  var layers = (
    <LayersControl position="topright" key={0}>
      <LayersControl.BaseLayer name={"Simple"}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png"
        />
      </LayersControl.BaseLayer>
      <LayersControl.BaseLayer checked name={"Satélite"}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
        />
      </LayersControl.BaseLayer>
      <LayersControl.BaseLayer name={"Oscuro"}>
        <TileLayer
          attribution={null}
          url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
        />
      </LayersControl.BaseLayer>
    </LayersControl>
  );

  // *********************************************************************************************************************************************************************************
  // ------------------------------------------------------------------- Layers configuration ----------------------------------------------------------------------------------------
  let enabledLayers = JSON.parse(sessionStorage.getItem("configuration"))[0].enabledLayers;
  let defaultLayers = JSON.parse(sessionStorage.getItem("configuration"))[0].defaultLayers;
  let ctLayer = <></>, invGeneralLayer = <></>, invPRLayer = <></>, ncuLayer = <></>, tcuLayer = <></>, rsuLayer = <></>;

    if(enabledLayers.includes("CT"))
      ctLayer = <LayersControl.Overlay name="CT" checked={defaultLayers.includes("CT")}>
                  <LayerGroup>
                    {htmlCT}
                  </LayerGroup>
                </LayersControl.Overlay>
      

    if(enabledLayers.includes("INV - General"))
      invGeneralLayer = <LayersControl.Overlay name="INV - General" checked={defaultLayers.includes("INV - General")}>
                          <LayerGroup>
                            {htmlINV}
                          </LayerGroup>
                        </LayersControl.Overlay>
      

    if(enabledLayers.includes("INV - PR %"))
      invPRLayer =  <LayersControl.Overlay name="INV - PR %" checked={defaultLayers.includes("INV - PR %")}>
                      <LayerGroup>
                        {htmlPR}
                      </LayerGroup>
                    </LayersControl.Overlay>
      

    if(enabledLayers.includes("NCU"))
        ncuLayer =  <LayersControl.Overlay name="NCU" checked={defaultLayers.includes("NCU")}>
                      <LayerGroup>
                        {htmlNCU}
                      </LayerGroup>
                    </LayersControl.Overlay>
      

    if(enabledLayers.includes("TCU"))
      tcuLayer =  <LayersControl.Overlay name="TCU" checked={defaultLayers.includes("TCU")}>
                    <LayerGroup>
                      {htmlTCU}
                    </LayerGroup>
                  </LayersControl.Overlay>
      

    if(enabledLayers.includes("RSU"))
        rsuLayer =  <LayersControl.Overlay name="RSU" checked={defaultLayers.includes("RSU")}>
                      <LayerGroup>
                        {htmlMS}
                      </LayerGroup>
                    </LayersControl.Overlay>;
      




  // *********************************************************************************************************************************************************************************
  // -------------------------------------------------------------------------- Mapa -------------------------------------------------------------------------------------------------
  var defMapX =(JSON.parse(sessionStorage.getItem("configuration"))[0].mapDefaultX);
  var defMapY=(JSON.parse(sessionStorage.getItem("configuration"))[0].mapDefaultY);
  var defZoom= (JSON.parse(sessionStorage.getItem("configuration"))[0].mapDefaultZoom);
  
  return(
    <MapContainer center={[defMapX, defMapY]} zoom={defZoom} scrollWheelZoom={true} maxZoom={20}>
      {layers}
      <LayersControl position="topleft" collapsed={false} key={1}>
        {ctLayer}
        {invGeneralLayer}
        {invPRLayer}
        {ncuLayer}
        {tcuLayer}
        {rsuLayer}
      </LayersControl>
      {htmlZona}
    </MapContainer>
  );
}

export default Map